/* ============
 * Vue BEM
 * ============
 *
 * BEM-style class name generator
 *
 * https://github.com/c01nd01r/vue-bem-cn
 */

import Vue from 'vue'
import vueBemCn from 'vue-bem-cn'

Vue.use(vueBemCn, {
  ns: '', // namespace
  el: '__', // element delimeter
  mod: '--', // modifier delimeter
  modValue: '-' // value delimeter for modifier
})



// WEBPACK FOOTER //
// ./src/app/plugins/vue-bem-cn.js